import React from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./spacer.module.scss";

const cx = c.bind(styles);
const rootClassName = "purpur-spacer";

export const SPACER_SIZE = ["xxxs", "xxs", "xs", "sm", "md", "lg", "xl", "xxl", "xxxl"] as const;

export type SpacerSize = (typeof SPACER_SIZE)[number];

export type SpacerProps = Omit<BaseProps, "children"> & {
  /** Width spacing size (horizontal) */
  width?: SpacerSize;
  /** Height spacing size (vertical) */
  height?: SpacerSize;
  /** Whether the spacer scales with breakpoints. Default is true (dynamic). */
  dynamic?: boolean;
  /** Divide the size in half */
  half?: boolean;
  /** Show background color based on size (for presentation/debugging) */
  background?: boolean;
};

export const Spacer = ({
  width,
  height,
  dynamic = false,
  half,
  background,
  className,
  ...props
}: SpacerProps) => (
  <div
    {...props}
    className={cx(className, rootClassName, {
      [`${rootClassName}--width-${width}`]: width,
      [`${rootClassName}--height-${height}`]: height,
      [`${rootClassName}--dynamic`]: dynamic,
      [`${rootClassName}--half`]: half,
      [`${rootClassName}--bg-${width || height}`]: background && (width || height),
    })}
  />
);
